import { connect } from 'react-redux';
import { isEligible } from 'store/app/selector';
import { State } from 'store/types';
import View from './View';

const mapStateToProps = (state: State) => {
  const { searchListingPage, appReducer, remoteConfig } = state;
  return {
    currentPage: appReducer.pageType,
    searchTerm: searchListingPage.searchTerm,
    hasVoiceSearch: isEligible(
      remoteConfig.configs?.AB?.voiceSearch,
      appReducer.run
    ),
    searchTextHp: remoteConfig.configs?.searchTextHp,
  };
};

export default connect(mapStateToProps)(View);
